import type { TooltipRenderProps } from 'react-joyride';
import LureoButton from '@/common/LureoButton';
import { Card } from '@/components/ui/card';
import { TextButton } from '@/components/ui/text-button';
import { CardTitle } from '@/components/ui/text';

// The dashboard and project tours' card as production draws it: frosted white, Skip on the left, Back and Next on the right (TourCard is the editor tutorial's, on the brand fill)
export function CmsTourTooltip({
  index,
  step,
  backProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep
}: TooltipRenderProps) {
  return (
    <Card {...tooltipProps} className="max-w-sm bg-lureo-surface/95 font-lureo-font-ui backdrop-blur-lureo-blur-sm">
      {step.title && (
        <CardTitle as="h3" className="mb-2 leading-7">
          {step.title}
        </CardTitle>
      )}
      <p className="mb-4 text-lureo-16 leading-6 text-lureo-ink-subtle">{step.content}</p>
      <div className="flex items-center justify-between gap-2">
        <TextButton {...skipProps} tone="quiet" className="text-lureo-14 font-normal leading-5">
          Skip
        </TextButton>
        <div className="flex gap-2">
          {index > 0 && (
            <LureoButton {...backProps} variant="outline-2" suppressTooltip className="rounded-lureo-radius-button-pill px-4 py-2 text-lureo-14 font-medium leading-5 text-lureo-ink-subtle">
              Back
            </LureoButton>
          )}
          <LureoButton {...primaryProps} variant="secondary" suppressTooltip className="rounded-lureo-radius-button-pill px-4 py-2 text-lureo-14 font-medium leading-5">
            {isLastStep ? 'Done' : 'Next'}
          </LureoButton>
        </div>
      </div>
    </Card>
  );
}
